// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from "./environment.model";

export const environment: Environment = {
  production: false,
  mockMode: false, // false, "partial", "full" @see dev docs
  apiUrl: "/passwordmanagement",
  siteKey: window["env"]["siteKey"] || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
  recaptchaEnabled: window["env"]["recaptchaEnabled"] ?? "true"
};

/*
// recaptchaSiteKEY "6LfR5KsUAAAAAJuZfMehXjomeVfk_tul5QPzDJLE";
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
